'use strict';

import Admin from './admin/admin.module';
import Proyectos from './proyectos/proyectos.module';
import Empresas from './empresas/empresas.module';

const Components = angular
    .module('app.components', [
        Admin,
        Proyectos,
        Empresas
    ])
    .name;

export default Components;



// WEBPACK FOOTER //
// ./src/app/components/components.js